import client from 'api/client';
import { AxiosRequestConfig } from 'axios';

export function get(
    resource_type: string,
    id?: string | number,
    customConfig?: AxiosRequestConfig
) {
    const url = id ? `resource/${resource_type}/${id}` : `resource/${resource_type}`;
    return client.get<{ url: string }>(url, customConfig);
}

export function post(resource_type: string, payload: FormData, customConfig?: AxiosRequestConfig) {
    return client.post(`resource/${resource_type}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
        ...customConfig,
    });
}
